module.exports = __webpack_public_path__ + "img/vertical_3_1_8004.347fa9f8.png";